export class DiceBet {
    constructor(public chosenRangeBorder: number, public belowNumber: boolean, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/api/DiceBet.ts